/**
 * GA4 event tracking helpers — TubeDealer marketplace (buyer-facing app).
 *
 * gtag.js is loaded synchronously in index.html (id G-XEN8E3LLPP).
 * This module wraps every call in a guard so test environments and
 * ad-blockers never throw — events silently no-op when gtag is absent.
 *
 * Key events tracked:
 *   sign_up   — new buyer account created via RegisterModal
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
function safeGtag(...args: unknown[]): void {
  if (typeof window !== "undefined" && typeof (window as any).gtag === "function") {
    (window as any).gtag(...args);
  }
}

export const analytics = {
  /**
   * Fire after a new buyer account is successfully created.
   * @param method  Sign-up channel, e.g. "Email" (default)
   */
  trackSignUp(method = "Email"): void {
    safeGtag("event", "sign_up", { method });
  },

  /**
   * Fire a GA4 page_view event with the current document title and URL.
   *
   * Call this AFTER react-helmet-async has committed the new <title> to the
   * DOM (i.e. inside a useEffect that runs post-render). Passing the values
   * explicitly prevents the "(not set)" page-title problem caused by GA4
   * reading document.title before React has updated it.
   *
   * @param title     Page title — defaults to document.title
   * @param location  Full URL — defaults to window.location.href
   */
  trackPageView(
    title = typeof document !== "undefined" ? document.title : "",
    location = typeof window !== "undefined" ? window.location.href : "",
  ): void {
    safeGtag("event", "page_view", {
      page_title: title,
      page_location: location,
    });
  },
} as const;
